import React from "react";
import {
  Image,
  Platform,
  ScrollView,
  useWindowDimensions,
  View,
  ViewStyle,
} from "react-native";
import ActionTile from "./ActionTile";
import { ScreenNameList, NavigationScreenName } from "@lib/utilities/Constants";
import {
  AGENT_ACTION_TILE_ICON,
  MAKE_PAYMENT_ACTION_TILE_ICON,
  CLAIM_ACTION_TILE_ICON,
  DOCS_ACTION_TILE_ICON,
  HOME_ICON,
  DOLLOR_WHITE_ICON,
  DOCS_WHITE_ICON,
  CALL_ICON,
  CLAIM_WHITE_ICON,
  AGENT_WHITE_ICON,
  DOLLOR_FADDED_ICON,
  DOCS_FADDED_ICON,
  CLAIM_FADDED_ICON,
  AGENT_FADDED_ICON,
} from "../../resources/IMAGES";
import { styles, ids } from "./ActionTilesStyle";
import { CONTACT_AGENT_ROUTE } from "../../navigation/NavigationConstants";
import { theme } from "../../theme/theme";
import { isLandscape, isTablet } from "react-native-device-info";
import { labelText } from "../../resources/strings";
import ActionTabs from "./ActionTabs";

const ActionTiles = ({ navigationToInnerScreens, variant }: any) => {
  const { height, width } = useWindowDimensions();
  const isActionTabs = variant === "actionTabs";

  const getOrientationStyle = (): ViewStyle => {
    if (!isTablet()) {
      return {};
    }
    return {
      ...Platform.select({
        ios: {
          transform: [{ scale: width == 1024 || width > 1200 ? 1.1 : 0.95 }],
          left: height > width ? "-8%" : 40,
        },
        android: {
          transform: [{ scale: height > width ? 0.85 : 0.9 }],
          left: height > width ? -100 : 40,
        },
        web: {},
      }),
    };
  };

  const tiles = [
    {
      containerStyle: [styles.agent],
      containerStyleIds: ids.agent,
      onPress: () =>
        navigationToInnerScreens(
          ScreenNameList.contactAgent,
          CONTACT_AGENT_ROUTE,
        ),
      textStyle: [styles.textServices, styles.textServicesAgent],
      textStyleIds: ids.textServices,
      title: labelText.actions.contactAgent,
      icon: AGENT_ACTION_TILE_ICON,
      iconStyle: styles.contactAgentIcon,
      iconStyleIds: ids.contactAgentIcon,
    },
    {
      containerStyle: styles.docs,
      containerStyleIds: ids.docs,
      onPress: () =>
        navigationToInnerScreens(
          ScreenNameList.billingPayments,
          NavigationScreenName.billingPayments,
        ),
      textStyle: styles.textServices,
      textStyleIds: ids.textServices,
      title: labelText.actions.billingAndPayments,
      icon: MAKE_PAYMENT_ACTION_TILE_ICON,
      iconStyle: styles.makePaymentIcon,
      iconStyleIds: ids.makePaymentIcon,
    },
    {
      containerStyle: styles.claim,
      containerStyleIds: ids.claim,
      onPress: () =>
        navigationToInnerScreens(
          ScreenNameList.makeClaim,
          NavigationScreenName.makeClaim,
        ),
      textStyle: [styles.textServices, styles.textServicesClaim],
      textStyleIds: ids.textServices,
      title: labelText.actions.makeClaim,
      icon: CLAIM_ACTION_TILE_ICON,
      iconStyle: styles.makeClaimIcon,
      iconStyleIds: ids.makeClaimIcon,
    },
    {
      containerStyle: styles.payment,
      containerStyleIds: ids.payment,
      onPress: () =>
        navigationToInnerScreens(
          ScreenNameList.documentInfo,
          NavigationScreenName.documentInfo,
        ),
      textStyle: styles.textServices,
      textStyleIds: ids.textServices,
      title: labelText.actions.docsAndInfo,
      icon: DOCS_ACTION_TILE_ICON,
      iconStyle: styles.docsInfoIcon,
      iconStyleIds: ids.docsInfoIcon,
    },
  ];

  if (isActionTabs) {
    return (
      <View
        style={[
          styles.actionTabsContainer,
          isTablet() && {
            paddingHorizontal: height > width ? theme.margin.lg : "10%",
          },
        ]}
        dataSet={{ media: ids.actionTabsContainer }}
      >
        <View
          style={styles.actionTabsOrientationChange}
          dataSet={{ media: ids.actionTabsOrientationChange }}
        >
          <ActionTabs
            key={1}
            tileIcon={DOLLOR_WHITE_ICON}
            onPress={tiles[1].onPress}
            title={labelText.actions.billingAndPaymentsNoCaps}
            icon={DOLLOR_FADDED_ICON}
            textStyleContainer={styles.textStyleContainer}
            tileColor={theme.colors.primary}
            iconStyle={styles.billingTabIconStyle}
            tileContainerStyle={styles.tileContainerStyle}
          />
          <ActionTabs
            tileIcon={DOCS_WHITE_ICON}
            key={3}
            onPress={tiles[3].onPress}
            title={labelText.actions.docsAndInfoNoCaps}
            textStyleContainer={styles.textStyleContainer}
            icon={DOCS_FADDED_ICON}
            tileColor={theme.colors.primary}
            iconStyle={styles.docsTabIconStyle}
            tileContainerStyle={styles.tileContainerStyle}
          />
        </View>
        <View style={[styles.actionTabBottomContainer]}>
          <ActionTabs
            key={2}
            onPress={tiles[2].onPress}
            tileIcon={CLAIM_WHITE_ICON}
            title={labelText.actions.makeClaimNoCaps}
            icon={CLAIM_FADDED_ICON}
            tileColor={theme.colors.secondary}
            containerStyle={styles.containerStyle}
            iconStyle={styles.billingTabIconStyle}
            tileContainerStyle={styles.tileContainerStyleOrientation}
            tileContainerStyleIds={ids.tileContainerStyleOrientation}
          />
          <ActionTabs
            key={0}
            onPress={tiles[0].onPress}
            title={labelText.actions.contactAgentNoCaps}
            tileIcon={AGENT_WHITE_ICON}
            icon={AGENT_FADDED_ICON}
            tileColor={theme.colors.secondary}
            containerStyle={styles.containerStyle}
            iconStyle={styles.billingTabIconStyle}
            tileContainerStyle={styles.tileContainerStyleOrientation}
            tileContainerStyleIds={ids.tileContainerStyleOrientation}
          />
        </View>
      </View>
    );
  }

  return (
    <View
      style={[
        styles.policyActionTiles,
        { minHeight: theme.height },
        getOrientationStyle(),
      ]}
      dataSet={{ media: ids.policyActionTiles }}
    >
      {tiles.map((tile, index) => (
        <ActionTile
          key={index}
          containerStyle={tile.containerStyle}
          containerStyleIds={tile.containerStyleIds}
          onPress={tile.onPress}
          textStyle={tile.textStyle}
          textStyleIds={tile.textStyleIds}
          title={tile.title}
          icon={tile.icon}
          iconStyle={tile.iconStyle}
          iconStyleIds={tile.iconStyleIds}
        />
      ))}
      {variant !== "actionTabs" && (
        <>
          <View
            style={styles.squareGreen}
            dataSet={{ media: ids.squareGreen }}
          />
          <View style={styles.squareBlue} dataSet={{ media: ids.squareBlue }} />
          <View style={styles.videoBlock} dataSet={{ media: ids.videoBlock }} />
          <View
            style={styles.squareGraphic}
            dataSet={{ media: ids.squareGraphic }}
          >
            <View
              style={styles.squareGraphicInner}
              dataSet={{ media: ids.squareGraphicInner }}
            >
              <Image
                style={styles.homeIcon}
                dataSet={{ media: ids.homeIcon }}
                source={HOME_ICON}
                testID="action-page-image"
              />
            </View>
          </View>
        </>
      )}
    </View>
  );
};

export default ActionTiles;
